import { addListener, removeListener, getAutocomplete } from "../../../../../../resources/js/utils";
import filterPill from "../../../views/pages/products/widgets/filter-pill.blade.php";
import { animateInput }           from "../../modules/utilities";
import { BRCollapse, BRDropdown } from "@dbetts/brjstools";

class ProductFilters
{
    showOutOfStock = 1;

    static categorySearchTerm = '';

    // Internal property for sortByType
    _sortByType = '1';

    constructor()
    {
        this.filterSearch = this.filterSearch.bind(this);
        this.clearFilterSearch = this.clearFilterSearch.bind(this);
        this.categoryLink = this.categoryLink.bind(this);
        this.setFilters =  this.setFilters.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.removeFilter = this.removeFilter.bind(this);
        this.showOOS = this.showOOS.bind(this);
        this.brandSearch = this.brandSearch.bind(this);
        this.setBrandFilter = this.setBrandFilter.bind(this);
        this.setPriceSelection = this.setPriceSelection.bind(this);
        this.filterAttributeValues = this.filterAttributeValues.bind(this);

        this.getItemsPerPage = this.getItemsPerPage.bind(this);
        this.getSortByType = this.getSortByType.bind(this);
        this.setSortByType = this.setSortByType.bind(this);

        this.PFInit();
    }

    PFInit()
    {
        this.setSidebarListeners();
        this.setAttributeSearchResults();

        /*  Initialize  */
        animateInput('price_min', document);
        animateInput('price_max', document);

        BRCollapse.initAll();
    }

    // Getter and Setter for sortByType
    get sortByType() {
        return this._sortByType;
    }

    set sortByType(value) {
        if (this._sortByType !== value) {
            this._sortByType = value;
        }
    }

    getSortByType() {
        return this.sortByType;
    }

    setSortByType(value) {
        this.sortByType = value; // Triggers the setter
    }

    setSidebarListeners()
    {
        addListener('keyup', '[data-input-filtersearch]', this.filterSearch);
        addListener('click', '[data-btn-filtersearchclear]', this.clearFilterSearch);
        addListener('click', '[data-set-category]', this.categoryLink);
        addListener('click', 'input[type="checkbox"][id^="attribute_"]', this.setFilters);
        addListener('click', '[data-btn-clearfilters]', this.clearFilters);
        addListener('click', '[data-btn-removefilter]', this.removeFilter);
        addListener('click', '[data-input-showoos]', this.showOOS);
        addListener('keyup', '[data-input-brandsearch]', this.brandSearch);
        addListener('click', 'input[type="checkbox"][id^="brand_"]', this.setBrandFilter);
        addListener('change', '[name="price_selection"]', this.setPriceSelection);
        addListener('click', '[data-btn-priceselection]', this.setPriceSelection);
        addListener('keyup', '#price_min', this.setPriceSelection);
        addListener('keyup', '#price_max', this.setPriceSelection);
        addListener('keyup', '[id^="attrValSearch_"]', this.filterAttributeValues);

        // Admin listeners
        addListener('change', '[name="limit_category"]', this.setAdminLimiter);

        // Mobile only listeners
        addListener('click', '[data-slide-menu]', this.slideMenu);
    }

    //#########################//
    //####  Page Loading   ####//
    //#########################//
    _pullPageFilterData(elementHref)
    {
        const url = new URL(elementHref !== undefined ? elementHref : window.location.href);
        let pathName = url.pathname;

        let queryParams = new URLSearchParams(url.search);
        let categoryId = queryParams.get('c1');
        let subCategoryId = queryParams.get('c2');
        let subSubCategoryId = queryParams.get('c3');
        let subSubCategoryName = undefined;
        let subCategoryName = undefined;
        let categoryName = undefined;

        let pathParts = pathName.split('/');
        if ( pathParts.length > 4 ) {
            subSubCategoryName = pathParts.pop();
            subCategoryName = pathParts.pop();
            categoryName = pathParts.pop();
        }
        else if ( pathParts.length > 3 ) {
            subCategoryName = pathParts.pop();
            categoryName = pathParts.pop();
        }
        else if ( pathParts.length > 2 ) {
            categoryName = pathParts.pop();
        }


        let attributeIDs = [];
        let attributeFilters = {};
        let brandIDs = [];
        let priceFilter = {};
        let expandedFilters = [];
        let limitCategory = undefined;
        let searchTerm = undefined;
        let searchLocal = false;
        const localSearch = document.querySelector('[data-input-filtersearch]');
        const globalSearch = document.querySelector('[data-br-dropdown="globalSearch"]');
        if (localSearch && localSearch.value !== '') {
            searchTerm = localSearch.value;
        }
        else if (globalSearch.value !== '') {
            searchTerm = globalSearch.value;
        }

        // Checkbox under sidebar to designate the search to local category only
        const searchLocalElement = document.querySelector('[data-input-filtersearch-local]');
        if (searchLocalElement) {
            searchLocal = searchLocalElement.checked;
        }

        // Get the active filter groups.
        document.querySelectorAll('div[data-br-collapse-view]').forEach(function(el) {
            if ( !el.classList.contains('hidden') ) {
                let parts = el.getAttribute('id').split('_');
                let id = parts[1];
                expandedFilters.push(id);
            }
        });

        // Get the selected attributes
        document.querySelectorAll('input[type="checkbox"][id^="attribute_"]').forEach(function(check) {

            let idParts = check.getAttribute('id').split('_');
            let attributeFilterId = idParts[1];

            if ( check.checked ) {
                let productAttributeId = idParts[2];
                let attributeValue = check.nextElementSibling.innerHTML.trim();
                attributeIDs.push(
                    {
                        'attr_fil_id': attributeFilterId,
                        'prod_attr_id': productAttributeId,
                        'prod_attr_value': attributeValue,
                    }
                );
            }

            // Look for a search filters
            let potential = check.parentElement.parentElement.children[0];
            if ( potential.children[0].getAttribute('id').includes('attrValSearch_') && potential.children[0].value !== '' ) {
                attributeFilters[attributeFilterId] = potential.children[0].value;
            }
        });

        // Get the brand selections
        document.querySelectorAll('input[type="checkbox"][id^="brand_"]').forEach(function(check) {
            if ( check.checked ) {
                let brandId = check.getAttribute('id').split('_').pop();
                brandIDs.push(
                    {
                        'brand_id': brandId,
                        'name': check.nextElementSibling.innerHTML.trim(),
                    }
                );
            }
        });

        // Get the price filters
        let min = '';
        let max = '';
        document.querySelectorAll('[name="price_selection"]').forEach(function(element) {
            if ( element.checked ) {
                switch ( element.getAttribute('id') ) {
                    case 'priceFilter_200':
                        min = 0;
                        max = 200;
                        break;
                    case 'priceFilter_500':
                        min = 200;
                        max = 500;
                        break;
                    case 'priceFilter_up':
                        min = 500;
                        max = 999999999;
                        break;
                }
            }
        });

        if ( min === '' ) {
            // Look for the price input values
            try {
                min = document.getElementById('price_min').value;
                max = document.getElementById('price_max').value;
            }
            catch ( err ) {
            }
        }

        if ( min !== '' && max !== '' )
            priceFilter = {min: min, max: max};

        // Look for Admin request
        let limitEl = document.querySelector('[name="limit_category"]:checked');
        if ( limitEl !== null )
            limitCategory = limitEl.value;


        let requestParams = {
            c1: categoryId,
            c2: subCategoryId,
            c3: subSubCategoryId,
            expanded_filters: expandedFilters,
            attribute_ids: attributeIDs,
            attribute_filters: attributeFilters,
            brand_ids: brandIDs,
            price_filter: priceFilter,
            limit_category: limitCategory,
            search_term: searchTerm,
            search_local: searchLocal,
            per_page: this.getSubclassItemsPerPage(),
            sort_by: this.getSubclassSortByType(),
            show_oos: this.showOutOfStock,
        };

        const axiosInstance = axios.create(
            {
                baseURL: route('products.search', {
                    categoryName: categoryName,
                    subCategoryName: subCategoryName,
                    subSubCategoryName: subSubCategoryName
                })
            }
        );

        return axiosInstance.getUri({params: requestParams});
    }

    getSubclassItemsPerPage()
    {
        return this.getItemsPerPage();
    }

    getSubclassSortByType()
    {
        return this.getSortByType();
    }

    getItemsPerPage()
    {
        throw new Error('getItemsPerPage() must be implemented by subclasses');
    }



    showOOS(evt)
    {
        this.showOutOfStock = evt.currentTarget.checked ? 1 : 0;
        localStorage.setItem('showOutOfStock', this.showOutOfStock + '');
        let pageURL = this._pullPageFilterData();
        this.getSubclassPageContent(pageURL);
    }

    setShowOOS(value)
    {
        this.showOutOfStock = parseInt(value);
    }

    filterSearch(evt)
    {
        let userInput = evt.currentTarget;
        this.categorySearchTerm = userInput.value;

        if ( userInput.value.length > 2 || userInput.value.length === 0 ) {
            sessionStorage.setItem('search_term', userInput.value);
            this.debouncedSearch();
        }
    }

    debouncedSearch = this.debounce(() => {
        const pageURL = this._pullPageFilterData();
        getAutocomplete(pageURL)
            .then(res => {
                if ( res.Status === 'Success' ) {
                    this.setSubclassProductsContent(pageURL, res.Result);
                }
                else {
                    console.log(res);
                }
            }).catch(error => {
            if ( error.message !== 'canceled' )
                console.log(error)
        });
    }, 300);

    debounce(func, delay)
    {
        let debounceTimer;
        return (...args) => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => func(...args), delay);
        }
    }

    getSubclassPageContent(pageURL, result)
    {
        this._getPageContent(pageURL, result);
    }

    _getPageContent()
    {
        throw new Error('_getPageContent() must be implemented by subclasses');
    }

    /**
     * This is called when a keyword search is performed in a category
     * @param pageURL
     * @param result
     */
    setSubclassProductsContent(pageURL, result)
    {
        if (result.product_list) {
            this.#setSearchDropdownData(result);
        }
        else {
            this.setProductsContent(pageURL, result);
        }
    }

    #setSearchDropdownData(dataResult)
    {
        const filterSearch = document.querySelector('[data-input-filtersearch]');
        const minWidth = filterSearch.offsetWidth;
        let   brDropdown = BRDropdown.getInstance(filterSearch);
        if (!brDropdown) {
            brDropdown = new BRDropdown(filterSearch, {
                trigger: 'none',
                vplacement: "bottom",
                hplacement: "left",
                searchable: false,
                static: false    // false = clicks outside the dropdown view close the view.
            });
        }

        // Add the background
        if ( brDropdown.brView.nextElementSibling === null || brDropdown.brView.nextElementSibling.getAttribute('data-br-backdrop') === null ) {
            const newElement = document.createElement('div');
            newElement.setAttribute('class', 'opacity-50 transition-all duration-300 ease-in-out fixed top-0 left-0 z-20 bg-black w-screen h-screen');
            newElement.setAttribute('data-br-backdrop', '');
            brDropdown.brView.insertAdjacentElement('afterend', newElement);
        }

        // Show the dropdown
        brDropdown.setBody( dataResult.product_list );
        brDropdown.brView.style.minWidth = `${minWidth}px`;

        // When a link is clicked, the brDropdown should close.
        addListener('click', brDropdown.brView.querySelectorAll('a'), () => brDropdown.hide());
        addListener('click', brDropdown.brView.querySelectorAll('[data-btn-global-search-cancel]'), () => {
            filterSearch.value = '';
            brDropdown.hide()
        });

        brDropdown.show({currentTarget:filterSearch});
    }

    setProductsContent()
    {
        throw new Error('setProductsContent() must be implemented by subclasses');
    }

    clearFilterSearch(evt)
    {
        let _this = evt.currentTarget;
        _this.previousElementSibling.value = '';
        this.debouncedSearch(_this.previousElementSibling);
    }

    categoryLink(evt)
    {
        evt.preventDefault();

        // Perform a DB request with the new checkboxes.
        let pageURL = this._pullPageFilterData(evt.currentTarget.getAttribute('href'));
        this.getSubclassPageContent(pageURL);
    }


    //###########################//
    //#### Filter Checkboxes ####//
    //###########################//
    setFilters(evt)
    {
        let check = evt.currentTarget;
        let isChecked = check.checked;
        let attributeValue = check.nextElementSibling.innerHTML.trim();
        let attributeId = check.getAttribute('id');

        // Add/Remove a Pill to/from the Filters header.
        if ( isChecked ) {
            // Add pill
            document.getElementById('filterPills').insertAdjacentHTML('beforeend', this.buildPill(attributeValue, attributeId));
        }
        else {
            // Remove pill
            let svg = document.querySelector('svg[data-attribute-id="' + attributeId + '"]');
            svg.closest('span').remove();
        }

        // Perform a DB request with the new checkboxes.
        let pageURL = this._pullPageFilterData();
        this.getSubclassPageContent(pageURL);
    }

    clearFilters()
    {
        document.getElementById('filterPills').innerHTML = '';

        // Clear standard attributes
        document.querySelectorAll('input[type="checkbox"][id^="attribute_"]').forEach(function(check) {
            check.checked = false;
        });

        // Clear brands
        document.querySelectorAll('input[type="checkbox"][id^="brand_"]').forEach(function(check) {
            check.checked = false;
        });
        document.querySelector('[data-input-brandsearch]').value = '';

        // Perform a DB request with the new checkboxes.
        let pageURL = this._pullPageFilterData();
        this.getSubclassPageContent(pageURL);
    }

    removeFilter(evt)
    {
        let svg = evt.currentTarget;

        let uncheckId = svg.getAttribute('data-attribute-id');
        if ( uncheckId !== null ) {
            // Remove the attribute
            const theCheck = document.getElementById(uncheckId);
            theCheck.removeAttribute('disabled');
            theCheck.click();
        }

        // Perform a DB request with the new checkboxes.
        let pageURL = this._pullPageFilterData();
        this.getSubclassPageContent(pageURL);
    }

    buildPill(attributeValue, attributeId)
    {
        // Remove blade comments from string.
        const commentRegex = /{{--[\s\S]*?--}}/g;
        try {
            return filterPill.replace(commentRegex, '').replace('{{$id}}', attributeId).replace('{{$name}}', attributeValue);
        }
        catch(err) {
            console.log(err);
            throw new Error('Error building pills.');
        }
    }

    //#################################//
    //#### Brand Filter/Checkboxes ####//
    //#################################//
    brandSearch(evt)
    {
        let btn = evt.currentTarget;
        let categoryName = undefined;
        let subCategoryName = undefined;
        let categoryId = undefined;

        // Pull the active category IDs.
        let pathname = window.location.pathname;
        let pathParts = pathname.split('/');
        if ( pathParts[1] === 'productSearch' ) {
            categoryName = pathParts[2];
            subCategoryName = pathParts[3] !== undefined ? pathParts[3] : undefined;

            let queryParams = new URLSearchParams(window.location.search);
            categoryId = queryParams.get('category_id');
        }

        let requestParams = {
            brand_name: btn.value.trim(),
            category_name: categoryName,
            subcategory_name: subCategoryName,
            category_id: categoryId
        };
        this.debouncedSearchBrand(requestParams);
    }

    debouncedSearchBrand = this.debounce((requestParams) => {
        getAutocomplete(route('products.search-brand'), requestParams).then(res => {
            if ( res.Status === 'Success' ) {
                // Clear existing brands
                let container = document.getElementById('filterBrandsContainer');
                container.innerHTML = '';

                // Insert the brand results
                let brands = res.Result.brands;
                for ( let key in brands ) {
                    if ( brands.hasOwnProperty(key) ) {
                        // Add the brand to the UI
                        container.appendChild(this.buildBrandCheckboxEntry(brands[key].id, brands[key].brand_name));
                    }

                    // Set the listener for the Checkboxes.
                    addListener('click', 'input[type="checkbox"][id^="brand_"]', this.setBrandFilter);
                }
            }
            else {
                console.log(res.Message);
            }
        }).catch(error => {
            if ( error.message !== 'canceled' )
                console.log(error)
        });
    }, 300);

    setBrandFilter()
    {
        // Perform a DB request with the new checkboxes.
        let pageURL = this._pullPageFilterData();
        this.getSubclassPageContent(pageURL);
    }

    buildBrandCheckboxEntry(brandId, brandName)
    {
        let div = document.createElement('div');
        let input = document.createElement('input');
        let label = document.createElement('label');

        div.setAttribute('class', 'mb-[0.125rem] block min-h-[1.5rem] pl-[1.5rem]');
        input.setAttribute('id', 'brand_' + brandId);
        input.setAttribute('type', 'checkbox');
        input.setAttribute('class', 'search-column-checkbox check-level-1');
        label.setAttribute('for', 'brand_' + brandId);
        label.setAttribute('class', 'inline-block pl-[0.15rem] hover:cursor-pointer');
        label.innerText = brandName;

        div.appendChild(input);
        div.appendChild(label);

        return div;
    }

    //#############################//
    //#### Price Filter/Inputs ####//
    //#############################//
    setPriceSelection(evt)
    {
        let elem = evt.currentTarget;
        let thisId = elem.getAttribute('id');
        document.querySelectorAll('[name="price_selection"]:not(#' + thisId + ')').forEach(function(element) {
            element.checked = false;
        });

        if ( evt.type !== 'keyup' || evt.key === 'Enter' ) {
            // Perform a DB request with the new checkboxes.
            let pageURL = this._pullPageFilterData();
            this.getSubclassPageContent(pageURL);
        }
    }


    //################################//
    //#### Attribute Value Filter ####//
    //################################//
    filterAttributeValues(evt)
    {
        let btnInput = evt.currentTarget;
        let searchVal = btnInput.value.toLowerCase();
        let attrNameId = btnInput.getAttribute('id').split('_').pop();

        let container = btnInput.closest('[data-br-collapse-view]');

        container.querySelectorAll('[id^="attribute_' + attrNameId + '_"]').forEach(input => {
            let label = input.nextElementSibling.textContent.toLowerCase();
            if ( label.includes(searchVal) ) {
                // Set it visible
                input.parentElement.classList.remove('hidden');
            }
            else {
                // Set it hidden
                input.parentElement.classList.add('hidden');
            }
        });
    }

    setAttributeSearchResults()
    {
        document.querySelectorAll('[id^="attrValSearch_"]').forEach(input => {
            if ( input.value !== '' ) {
                let event = new KeyboardEvent('keyup', {});
                input.dispatchEvent(event);
            }
        });
    }


    //####################//
    //#### Admin Only ####//
    //####################//
    setAdminLimiter(evt)
    {
        // If the checkbox is checked, we need to add a query string to the categories.
        // Else, we need to remove the query string.

        let check = evt.currentTarget;
        if ( check.checked ) {
            // Add the query string to any link that has children (has secondary or tertiary categories)
            Array.from(document.getElementById('categories_container').children[1].children).forEach(function(div) {

                let typeDiv = div.getAttribute('data-type');
                switch ( typeDiv ) {
                    case 'primary':
                    case 'secondary':
                        let aTag = div.querySelector('a');
                        let url = new URL(aTag.getAttribute('href'));
                        url.searchParams.set('limit_category', '1');

                        aTag.href = url.toString();
                        break;
                    case 'tertiary':
                        Array.from(div.children).forEach(function(terDiv) {
                            let aTag = terDiv.querySelector('a');
                            let url = new URL(aTag.getAttribute('href'));
                            url.searchParams.set('limit_category', '1');

                            aTag.href = url.toString();
                        });
                        break;
                    default:
                        break;
                }
            });
        }
        else {
            // Remove the query string
            Array.from(document.getElementById('categories_container').children[1].children).forEach(function(div) {

                let typeDiv = div.getAttribute('data-type');
                switch ( typeDiv ) {
                    case 'primary':
                    case 'secondary':
                        let aTag = div.querySelector('a');
                        let url = new URL(aTag.getAttribute('href'));
                        url.searchParams.delete('limit_category');

                        aTag.href = url.toString();
                        break;
                    case 'tertiary':
                        Array.from(div.children).forEach(function(terDiv) {
                            let aTag = terDiv.querySelector('a');
                            let url = new URL(aTag.getAttribute('href'));
                            url.searchParams.delete('limit_category');

                            aTag.href = url.toString();
                        });
                        break;
                    default:
                        break;
                }
            });
        }
    }


    //#####################//
    //#### Mobile Only ####//
    //#####################//
    
    slideMenu()
    {
        let menu = document.querySelector('#menuContainer');
        let masterButton = document.querySelector('[data-slide-menu]');
        let filtersWrapper = document.getElementById('filters__wrapper');
        menu.classList.toggle('active');
        masterButton.parentElement.parentElement.classList.add('top-0');
        masterButton.parentElement.classList.add('w-full');
        if ( menu.classList.contains('active') ) {

            masterButton.innerText = 'Close';
            filtersWrapper.classList.add('h-screen','absolute', 'top-0','w-full', 'z-[1337]');
             masterButton.parentElement.parentElement.classList.add('top-0','active', 'fixed');
             masterButton.parentElement.parentElement.style.position = 'fixed';
             masterButton.parentElement.parentElement.style.top = '0';

            }
        else {

            const wrapperClasses = ['h-screen','absolute', 'top-0','w-full', 'z-[1337]']
            masterButton.innerText = 'Filters';
            masterButton.parentElement.parentElement.classList.remove('top-0');
            masterButton.parentElement.parentElement.classList.remove('fixed');
            masterButton.parentElement.parentElement.classList.remove('active');
            document.querySelector('#searchChildHeader').style.marginTop = `0`;
            masterButton.parentElement.parentElement.style.position = 'relative';
            wrapperClasses.map( (className) => {
                filtersWrapper.classList.remove(className);
            });
        }
    }

    
}

export default ProductFilters;